import { GetTierForUserType, getTierForUser } from '.'
import { AiUserSubscription, BillingCycle, StripeConfigIdObject } from '../../types'
import {
  DEV_ANNUAL_SUBSCRIPTION_IDS,
  DEV_MONTHLY_SUBSCRIPTION_IDS,
  PROD_ANNUAL_SUBSCRIPTION_IDS,
  PROD_MONTHLY_SUBSCRIPTION_IDS
} from './constants'

export class SharedStripeConfig {
  public static subscriptionPriceIds(isProd: boolean): StripeConfigIdObject {
    if (isProd) {
      return {
        [BillingCycle.MONTHLY]: PROD_MONTHLY_SUBSCRIPTION_IDS.PRICE,
        [BillingCycle.ANNUAL]: PROD_ANNUAL_SUBSCRIPTION_IDS.PRICE
      }
    } else {
      return {
        [BillingCycle.MONTHLY]: DEV_MONTHLY_SUBSCRIPTION_IDS.PRICE,
        [BillingCycle.ANNUAL]: DEV_ANNUAL_SUBSCRIPTION_IDS.PRICE
      }
    }
  }

  public static subscriptionProductIds(isProd: boolean): StripeConfigIdObject {
    if (isProd) {
      return {
        [BillingCycle.MONTHLY]: PROD_MONTHLY_SUBSCRIPTION_IDS.PRODUCT,
        [BillingCycle.ANNUAL]: PROD_ANNUAL_SUBSCRIPTION_IDS.PRODUCT
      }
    } else {
      return {
        [BillingCycle.MONTHLY]: DEV_MONTHLY_SUBSCRIPTION_IDS.PRODUCT,
        [BillingCycle.ANNUAL]: DEV_ANNUAL_SUBSCRIPTION_IDS.PRODUCT
      }
    }
  }

  public static getPriceId(
    aiUser: GetTierForUserType,
    subscription: AiUserSubscription,
    billingCycle: BillingCycle,
    isProd: boolean
  ) {
    const subscriptionType = getTierForUser({ ...aiUser, subscription, billingCycle })
    return subscriptionType.getPriceId(billingCycle, isProd)
  }

  public static getSubscriptionFromPriceId(priceId: string, isProd: boolean) {
    const priceMap = this.subscriptionPriceIds(isProd)
    const billingCycles = Object.keys(priceMap) as BillingCycle[]
    const tiers = Object.keys(priceMap[billingCycles[0]]) as AiUserSubscription[]

    for (const billingCycle of billingCycles) {
      const billingCyclePriceMap = priceMap[billingCycle]
      for (const tier of tiers) {
        const priceIds = billingCyclePriceMap[tier]
        if (priceIds.includes(priceId)) {
          return {
            tier,
            billingCycle
          }
        }
      }
    }

    const message = 'Invalid price id'
    throw new Error(message)
  }
}
